// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { isConfigurationCompleted } from "@insite/client-framework/Store/Pages/ProductDetails/ProductDetailsSelectors";
import ProductDetailsState from "@insite/client-framework/Store/Pages/ProductDetails/ProductDetailsState";
import {
    ConfigurationModel,
    ProductInventoryDto,
    ProductPriceDto,
    ProductSubscriptionDto,
    RealTimeInventoryModel,
} from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

/* Store Custom Code - Start */
import {
    isConfigSectionEmbroidery,
    isSectionOptionRequired,
} from "@store/Framework/Common/Utilities/embroideriesUtilities";
/* Store Custom Code - End */

const initialState: ProductDetailsState = {
    selectedImageIndex: 0,
    variantSelection: {},
    variantSelectionCompleted: false,
    configurationSelection: {},
    configurationCompleted: false,
    // Store Custom Code
    configurationEmbroideries: {},
};

const reducer = {
    "Pages/ProductDetails/CompleteLoadProduct": (
        draft: Draft<ProductDetailsState>,
        action: {
            productInfosById: SafeDictionary<ProductInfo>;
            variantSelection: SafeDictionary<string>;
            selectedProductId?: string;
            configuration?: ConfigurationModel | null;
        },
    ) => {
        draft.selectedProductId = action.selectedProductId;
        draft.productInfosById = action.productInfosById;
        draft.selectedImageIndex = 0;
        draft.variantSelection = action.variantSelection;
        draft.subscription = undefined;
        draft.isProductLoading = false;
        initConfigurationSelection(draft, action.configuration); // Store Custom Code - Using custom initConfigurationSelection declared below
    },
    "Pages/ProductDetails/InitConfigurationSelection": (
        draft: Draft<ProductDetailsState>,
        action: { configuration?: ConfigurationModel | null },
    ) => {
        initConfigurationSelection(draft, action.configuration); // Store Custom Code - Using custom initConfigurationSelection declared below
    },
    /* Store Custom Code - Start */
    "Pages/ProductDetails/RemoveConfigurationSelection": (
        draft: Draft<ProductDetailsState>,
        action: {
            configurationSelection: SafeDictionary<string>;
            configurationCompleted: boolean;
        },
    ) => {
        draft.configurationSelection = action.configurationSelection;
        draft.configurationCompleted = action.configurationCompleted;
    },
    "Pages/ProductDetails/UpdateConfigurationEmbroideries": (
        draft: Draft<ProductDetailsState>,
        action: {
            configurationEmbroideries: SafeDictionary<string>;
        },
    ) => {
        draft.configurationEmbroideries = action.configurationEmbroideries;
    },
    "Pages/ProductDetails/ResetConfigurationEmbroideries": (draft: Draft<ProductDetailsState>) => {
        draft.configurationEmbroideries = initialState.configurationEmbroideries;
    },
    /* Store Custom Code - End */
    "Pages/ProductDetails/ResetSelections": (draft: Draft<ProductDetailsState>) => {
        draft.selectedImageIndex = initialState.selectedImageIndex;
        draft.variantSelection = initialState.variantSelection;
        draft.variantSelectionCompleted = initialState.variantSelectionCompleted;
        draft.configurationSelection = initialState.configurationSelection;
        draft.configurationCompleted = initialState.configurationCompleted;
        draft.lastStyledOption = initialState.lastStyledOption;
        // Store Custom Code
        draft.configurationEmbroideries = initialState.configurationEmbroideries;
    },
};

const initConfigurationSelection = (draft: Draft<ProductDetailsState>, configuration?: ConfigurationModel | null) => {
    draft.configurationSelection = {};
    configuration?.configSections?.forEach(configSection => {
        /* Store Custom Code - Start */
        if (isConfigSectionEmbroidery(configSection)) {
            /**
             * When section is of type Embroidery, initial configurationSelection state needs to contains 
             * section.id to make sure embroidery is required for isConfigurationCompleted validation
             */
            configSection.sectionOptions?.forEach(section => {
                if (isSectionOptionRequired(section)) {
                    draft.configurationSelection[section.id] = "";
                }
            });
            // We ignore optional embroideries
            return;
        }
        /* Store Custom Code - End */

        draft.configurationSelection[configSection.id] = configSection.sectionOptions?.find(o => o.selected)?.id || "";
    });
    draft.configurationCompleted = isConfigurationCompleted(draft.configurationSelection);
};

export default createTypedReducerWithImmer(initialState, reducer);
